export default "skymp5-front/49988be1b3361424a38654e26652e119.png";